import { useTranslation } from 'react-i18next';
import { MockAppFrame } from '../mock-app-frame.jsx';
import { TransactionsCard } from '../transactions-card.jsx';

/**
 * Transfers use-case mockup: the real transactions feed with transfer pairs.
 * @returns {JSX.Element}
 */
export function TransfersScreen() {
	const { t } = useTranslation();
	return (
		<>
			<MockAppFrame>
				<TransactionsCard />
			</MockAppFrame>
			<div className="use-case-callout card">
				<h3>{t('usecase.transfers.flow.title')}</h3>
				<p>{t('usecase.transfers.flow.body')}</p>
			</div>
		</>
	);
}
